import { Card, Col, Row } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDealerSlideShow } from "../../reducers/authSlice";

const Profile = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDealerSlideShow(false));
  }, [dispatch]);

  return (
    <Row justify="center" className="mt1">
      <Col span={12}>
        <Card bordered={false} title="Profile" styles={{ body: { padding: "20px" } }}>
          <Row gutter={16}>
            <Col className="bold">Name: </Col>
            <Col>
              {userDetails?.firstName} {userDetails?.lastName}
            </Col>
          </Row>
          <Row gutter={16} className="mt1">
            <Col className="bold">Email: </Col>
            <Col>{userDetails?.email}</Col>
          </Row>
          <Row gutter={16} className="mt1">
            <Col className="bold">Organisation: </Col>
            <Col>
              {userDetails?.mainOrganisation?.name} -{" "}
              {userDetails?.mainOrganisation?.type}
            </Col>
          </Row>
          <Row gutter={16} className="mt1">
            <Col className="bold">Role: </Col>
            <Col>{userDetails?.currentRole}</Col>
          </Row>
          <Row gutter={16} className="mt1">
            <Col className="bold">Phone: </Col>
            <Col>{userDetails?.phoneNumber}</Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default Profile;
